const emailRegularExpress = /^([A-Za-z0-9_+\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,10})$/;

const VerifyEmailFormat = (email: string) => emailRegularExpress.test(email);

export default VerifyEmailFormat;
